var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.proposals),function(proposal){return _c('ProductGrid',{key:proposal.id,attrs:{"proposal":proposal,"title":_vm.title ? _vm.title : proposal.descr,"paginationClass":_vm.paginationClass + proposal.id,"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }